import { ApiAction, initialPaginatedApiState, PaginatedApiState } from '../../utils/requestAction'
import requestReducer from '../requestReducer'
import { CurrentAccountSummary } from '../../models/CurrentAccountSummary'

export interface CurrentAccountSummaryListState extends PaginatedApiState {
  summary?: CurrentAccountSummary[]
}

const CurrentAccountSummaryList = (
  state: CurrentAccountSummaryListState = initialPaginatedApiState,
  action: ApiAction
) => {
  switch (action.type) {
    default:
      return requestReducer<CurrentAccountSummaryListState>(
        'CURRENT_ACCOUNT_SUMMARY'
      )(state, action)
  }
}

export default CurrentAccountSummaryList
